import dayjs from 'dayjs';

import { i18n } from '../i18n';

const cache = new Map();

// Many Chromium/Electron ICU builds lack Uzbek number data and silently fall back to en-US
// ("1,234.5"). Uzbek uses the same grouping as ru-RU: "1 234,5".
const numberLocale = () => (i18n.meta.compact ? 'ru-RU' : i18n.meta.intl);

const getFormatter = (key, options) => {
  const intl = numberLocale();
  const cacheKey = `${intl}|${key}`;
  if (!cache.has(cacheKey)) {
    let formatter;
    try {
      formatter = new Intl.NumberFormat(intl, options);
    } catch (e) {
      formatter = new Intl.NumberFormat('ru-RU', options);
    }
    cache.set(cacheKey, formatter);
  }
  return cache.get(cacheKey);
};

const toNumber = value => {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};

export const formatNumber = number =>
  getFormatter('int', { maximumFractionDigits: 0 }).format(toNumber(number));

export const formatMoney = number => `${formatNumber(number)} ${i18n.t('common.currency')}`;

const COMPACT_STEPS = [1e9, 1e6, 1e3];

export const formatCompact = number => {
  const n = toNumber(number);
  if (Math.abs(n) < 10000) return formatNumber(n);
  const units = i18n.meta.compact;
  if (units) {
    const index = COMPACT_STEPS.findIndex(step => Math.abs(n) >= step);
    const value = getFormatter('compact-uz', { maximumFractionDigits: 1 }).format(n / COMPACT_STEPS[index]);
    return `${value} ${units[COMPACT_STEPS.length - 1 - index]}`;
  }
  return getFormatter('compact', { notation: 'compact', maximumFractionDigits: 1 }).format(n);
};

export const formatPercent = (value, digits = 1) =>
  getFormatter(`pct${digits}`, {
    style: 'percent',
    maximumFractionDigits: digits,
    minimumFractionDigits: 0,
  }).format(toNumber(value));

export const formatDate = (date, format = 'D MMM YYYY') => dayjs(date).format(format);

export const formatDateShort = date => dayjs(date).format('D MMM');
